"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrangeAnnotations = void 0;
exports.snapLabelToLeftSide = snapLabelToLeftSide;
exports.snapLabelToRightSide = snapLabelToRightSide;
exports.distributeLabelsVertically = distributeLabelsVertically;
exports.sortMarkersByYCoord = sortMarkersByYCoord;
exports.labelHeight = labelHeight;
exports.moveLabelTowardsMarker = moveLabelTowardsMarker;
var tslib_1 = require("tslib");
var model_1 = require("../model");
var draw_state_1 = require("./draw.state");
var label_draw_svg_1 = require("./drawable/label.draw.svg");
/**
 * ArrangeAnnotations moves the Label drawables on a given {@link IkeDraw} so that
 * they are neatly arranged without overlapping.
 * @param draw The IkeDraw to arrange labels for
 * @param renderOptions The SVGRenderOptions currently being used to render the IkeDraw
 * @param margin How many pixels to place between adjacent labels
 * @param iterations Optional. The number of times to run the arrangement algorithm (defaults to 100)
 */
var ArrangeAnnotations = /** @class */ (function () {
    function ArrangeAnnotations(draw, renderOptions, margin, iterations) {
        if (margin === void 0) { margin = 20; }
        if (iterations === void 0) { iterations = 100; }
        this.draw = draw;
        this.renderOptions = renderOptions;
        this.margin = margin;
        this.iterations = iterations;
    }
    Object.defineProperty(ArrangeAnnotations.prototype, "markersWithLabels", {
        get: function () {
            return this.draw.drawState.getAllDrawables()
                .filter(function (d) { return model_1.CollectionModelDrawableMarker.isMarker(d) || model_1.CollectionModelDrawableMarkerOffset.isBaseOffset(d); })
                .filter(function (m) { return m.label; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArrangeAnnotations.prototype, "labels", {
        get: function () {
            return this.markersWithLabels.map(function (m) { return m.label; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArrangeAnnotations.prototype, "markersWithLabelsLeftSide", {
        get: function () {
            var _this = this;
            return this.markersWithLabels.filter(function (m) { return m.label && m.label.state && m.label.state.x < _this.draw.capture.resolution.width / 2; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArrangeAnnotations.prototype, "markersWithLabelsRightSide", {
        get: function () {
            var _this = this;
            return this.markersWithLabels.filter(function (m) { return m.label && m.label.state && m.label.state.x >= _this.draw.capture.resolution.width / 2; });
        },
        enumerable: false,
        configurable: true
    });
    ArrangeAnnotations.prototype.run = function () {
        for (var _i = 0, _a = this.markersWithLabelsLeftSide; _i < _a.length; _i++) {
            var leftMarker = _a[_i];
            snapLabelToLeftSide(this.draw.capture, leftMarker.label);
        }
        for (var _b = 0, _c = this.markersWithLabelsRightSide; _b < _c.length; _b++) {
            var rightMarker = _c[_b];
            snapLabelToRightSide(this.draw.capture, rightMarker.label);
        }
        distributeLabelsVertically(this.draw, this.renderOptions, this.markersWithLabelsLeftSide);
        distributeLabelsVertically(this.draw, this.renderOptions, this.markersWithLabelsRightSide);
        for (var i = 0; i < this.iterations; i++) {
            // Alternate between moving labels in regular and reverse order for each pass.
            var labels = i % 2 === 0 ? this.labels : this.labels.reverse();
            var _loop_1 = function (label) {
                if (!label.parent || !label.state || (!model_1.CollectionModelDrawableMarker.isMarker(label.parent) && !model_1.CollectionModelDrawableMarkerOffset.isBaseOffset(label.parent))) {
                    return "continue";
                }
                var sameSideLabels = label.state.x < this_1.draw.capture.resolution.width / 2 ? this_1.markersWithLabelsLeftSide : this_1.markersWithLabelsRightSide;
                var otherLabels = sameSideLabels.map(function (marker) { return marker.label; }).filter(function (other) { return other !== label; });
                moveLabelTowardsMarker(label, label.parent, otherLabels, this_1.draw, this_1.renderOptions, this_1.margin);
            };
            var this_1 = this;
            for (var _d = 0, labels_1 = labels; _d < labels_1.length; _d++) {
                var label = labels_1[_d];
                _loop_1(label);
            }
        }
    };
    return ArrangeAnnotations;
}());
exports.ArrangeAnnotations = ArrangeAnnotations;
/**
 * Move a label to the left so that its left edge is touching the left side of the image.
 * @param capture The image containing the label
 * @param label The label to be moved
 */
function snapLabelToLeftSide(_, label) {
    if (!label.state) {
        return;
    }
    label.Mutator.move(0, label.state.y);
}
/**
 * Move a label to the right so that its right edge is touching the right side of the image.
 * @param capture The image containing the label
 * @param label The label to be moved
 */
function snapLabelToRightSide(capture, label) {
    if (!label.state) {
        return;
    }
    label.Mutator.move(capture.resolution.width - label_draw_svg_1.LABEL_SIZE.width * draw_state_1.DEFAULT_SCALE, label.state.y);
}
/**
 * Distribute the given labels of the given markers vertically so that there is
 * an equal amount of space between each label on the Y-axis.
 * The top and bottom labels will touch the top and bottom edge of the image respectively.
 * The labels will be sorted on the Y axis in the same order as their corresponding markers.
 * @param capture The image containing the labels
 * @param markers The markers whose labels will be distributed vertically
 */
function distributeLabelsVertically(draw, renderOptions, markers) {
    var markersWithLabels = markers.filter(function (m) { return m.state && m.label && m.label.state; });
    // Do not attempt to distribute if less than two labels are present
    if (markersWithLabels.length < 2) {
        return;
    }
    // Set the Y coord of each label to be equal to their corresponding marker
    for (var _i = 0, markersWithLabels_1 = markersWithLabels; _i < markersWithLabels_1.length; _i++) {
        var marker = markersWithLabels_1[_i];
        marker.label.Mutator.move(marker.label.state.x, marker.state.y);
    }
    // Calculate the margin to place between each label
    var sumOfLabelHeights = markersWithLabels.reduce(function (sum, m) { return sum + labelHeight(draw, renderOptions, m.label); }, 0);
    var margin = (draw.capture.resolution.height - sumOfLabelHeights) / (markersWithLabels.length - 1);
    // Sort the markers (and their labels) by their Y coordinates,
    // so that we can iterate through them from highest to lowest vertical position
    var sortedMarkers = sortMarkersByYCoord(markersWithLabels);
    var offsetFromTop = 0;
    // Distribute the labels with equal margin between them.
    // The labels will now be sorted on the Y axis in the same order as their corresponding markers.
    for (var _a = 0, _b = sortedMarkers.map(function (m) { return m.label; }); _a < _b.length; _a++) {
        var label = _b[_a];
        label.Mutator.move(label.state.x, Math.round(offsetFromTop));
        offsetFromTop += labelHeight(draw, renderOptions, label) + margin;
    }
}
function sortMarkersByYCoord(markers) {
    return tslib_1.__spreadArray([], markers, true).sort(function (a, b) { return a.state.y - b.state.y; });
}
function labelHeight(draw, renderOptions, label) {
    var _a;
    if (!((_a = label.parent) === null || _a === void 0 ? void 0 : _a.state)) {
        return label_draw_svg_1.LabelSVGDraw.height(1) * draw_state_1.DEFAULT_SCALE;
    }
    var textLines = draw.getLabelText(label.parent.state.id, renderOptions);
    return label_draw_svg_1.LabelSVGDraw.height(textLines.length) * draw_state_1.DEFAULT_SCALE;
}
/**
 * Move a label towards a given marker vertically until it either hits another label,
 * or becomes vertically centered at the Y-coordinate of the marker.
 * @param label The label to move
 * @param marker The marker to move towards
 */
function moveLabelTowardsMarker(label, marker, otherLabels, draw, renderOptions, margin) {
    if (!label.state || !marker.state) {
        return;
    }
    if (label.state.y === marker.state.y) {
        return;
    }
    var direction = label.state.y - marker.state.y > 0 ? 'up' : 'down';
    var closestLabel = direction === 'up'
        ? getClosestLabelUp(label, otherLabels, draw, renderOptions)
        : getClosestLabelDown(label, otherLabels, draw, renderOptions);
    var targetPos = direction === 'up'
        ? getTargetPositionUp(closestLabel, label, marker, margin, draw, renderOptions)
        : getTargetPositionDown(closestLabel, label, marker, margin, draw, renderOptions);
    label.Mutator.move(label.state.x, targetPos);
}
function getTargetPositionUp(closestLabel, label, marker, margin, draw, renderOptions) {
    if (!label.state || !marker.state) {
        throw new Error('Label, Marker, and Closest Label must have state');
    }
    var targetMarkerHeight = marker.state.y;
    if (!closestLabel) {
        return targetMarkerHeight;
    }
    if (!closestLabel.state) {
        throw new Error('Closest Label must have state');
    }
    var targetClosestLabelHeight = closestLabel.state.y + labelHeight(draw, renderOptions, closestLabel) + margin;
    if (label.state.y - targetClosestLabelHeight < label.state.y - targetMarkerHeight) {
        return targetClosestLabelHeight;
    }
    return Math.max(0, targetMarkerHeight);
}
function getTargetPositionDown(closestLabel, label, marker, margin, draw, renderOptions) {
    if (!label.state || !marker.state) {
        throw new Error('Label, Marker, and Closest Label must have state');
    }
    var height = labelHeight(draw, renderOptions, label);
    // If the marker is near the bottom edge of the image, only slide to the bottom edge of the image if that's closer
    var targetMarkerHeight = Math.min(draw.capture.resolution.height - labelHeight(draw, renderOptions, label), marker.state.y);
    if (!closestLabel) {
        return targetMarkerHeight;
    }
    if (!closestLabel.state) {
        throw new Error('Closest Label must have state');
    }
    var targetClosestLabelHeight = closestLabel.state.y - height - margin;
    // If the distance between the bottom of the label and the top of the closest label (plus a margin) is
    // less than the distance between the bottom of the label and the marker, then target the top of the closest label (plus a margin).
    if (targetClosestLabelHeight - label.state.y < targetMarkerHeight - label.state.y) {
        return targetClosestLabelHeight;
    }
    return targetMarkerHeight;
}
function getClosestLabelUp(label, otherLabels, draw, renderOptions) {
    if (!label.state) {
        return null;
    }
    var closest = null;
    var closestBottom = null;
    for (var _i = 0, otherLabels_1 = otherLabels; _i < otherLabels_1.length; _i++) {
        var otherLabel = otherLabels_1[_i];
        if (!otherLabel.state) {
            continue;
        }
        var otherLabelBottom = labelHeight(draw, renderOptions, otherLabel) + otherLabel.state.y;
        if (otherLabelBottom > label.state.y) {
            // Other label is overlapping or below, so skip it.
            continue;
        }
        if (!closest || !closestBottom) {
            closest = otherLabel;
            closestBottom = otherLabelBottom;
            continue;
        }
        if (otherLabelBottom < label.state.y && otherLabelBottom > closestBottom) {
            closest = otherLabel;
            closestBottom = otherLabelBottom;
        }
    }
    return closest;
}
function getClosestLabelDown(label, otherLabels, draw, renderOptions) {
    if (!label.state) {
        return null;
    }
    var bottom = labelHeight(draw, renderOptions, label) + label.state.y;
    var closest = null;
    for (var _i = 0, otherLabels_2 = otherLabels; _i < otherLabels_2.length; _i++) {
        var otherLabel = otherLabels_2[_i];
        if (!otherLabel.state) {
            continue;
        }
        if (otherLabel.state.y < bottom) {
            // Other label is overlapping or below, so skip it.
            continue;
        }
        if (!closest) {
            closest = otherLabel;
            continue;
        }
        if (!closest.state) {
            return null; // Will never happen (fingers crossed)
        }
        if (otherLabel.state.y > bottom && otherLabel.state.y < closest.state.y) {
            closest = otherLabel;
        }
    }
    return closest;
}
//# sourceMappingURL=ArrangeAnnotations.js.map